<template>
  <v-card>
    <v-toolbar color="primary" class="text-white rounded-0" height="80px">
      <v-toolbar-title class="ml-3">
        <h2>Statü Bazlı Kampanya Raporu</h2>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :hide-details="true"
            v-model="dateRangeText"
            style="width: 100%; max-width: 220px"
            label="Tarih Aralığı"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            dark
          ></v-text-field>
        </template>
        <v-date-picker v-model="rangeDates" range scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="menu = false">OK</v-btn>
        </v-date-picker>
      </v-menu>
      <KTTopMenu />
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="reportData"
      :loading="loading"
      :multi-sort="true"
      :items-per-page="100"
      item-key="campaign_name"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.campaign_name }}</td>
          <td v-for="status in statuses" :key="status.name" class="text-center">
            {{ item[status.name] === 0 ? "" : item[status.name] }}
          </td>
          <td>{{ item.total_lead }}</td>
        </tr>
      </template>

      <template v-slot:body.append>
        <tr>
          <td>
            <strong>{{ grandTotalRow.total_name }}</strong>
          </td>
          <td v-for="status in statuses" :key="status.id" class="text-center">
            <strong>{{ grandTotalRow[status.name] || 0 }}</strong>
          </td>
          <td>
            <strong>{{ grandTotalRow.total_lead }}</strong>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import AxiosInstance from "@/core/services/axios.service";
import KTTopMenu from "@/view/layout/header/TopMenu.vue";
import moment from "moment";

export default {
  name: "CampaignStatusReport",
  components: { KTTopMenu },
  data() {
    return {
      reportData: [],
      menu: false,
      loading: false,
      rangeDates: [
        moment().subtract(1, "month").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      statuses: [
        { id: 1, name: "Yeni" },
        { id: 2, name: "Görüşme" },
        { id: 3, name: "Teklif Taslağı Oluşturuldu" },
        { id: 4, name: "E-Posta Doğrulanması Bekleniyor" },
        { id: 5, name: "Teklif Gönderildi" },
        { id: 6, name: "Atandı" },
        { id: 7, name: "U1" },
        { id: 8, name: "U2" },
        { id: 9, name: "U3" },
        { id: 10, name: "Kayıt Tamamlandı" },
        { id: 11, name: "Kullanıcı Kaydı Tamamlandı" },
        { id: 12, name: "Satılamadı" },
        { id: 13, name: "Sunum Yapıldı" },
      ],
    };
  },
  computed: {
    headers() {
      return [
        {
          value: "campaign_name",
          text: "Kampanya Adı",
          align: "left",
        },
        ...this.statuses.map((status) => ({
          text: this.getLeadStatusTranslate(status.name),
          value: status.name,
          align: "center",
        })),
        { value: "total_lead", text: "TOTAL", align: "center" },
      ];
    },
    dateRangeText() {
      if (
        this.rangeDates &&
        this.rangeDates.length === 2 &&
        this.rangeDates[0] &&
        this.rangeDates[1]
      ) {
        return (
          moment(this.rangeDates[0]).format("DD.MM.YYYY") +
          " -- " +
          moment(this.rangeDates[1]).format("DD.MM.YYYY")
        );
      }
      return "";
    },
    grandTotalRow() {
      const totalRow = {
        total_name: "TOTAL",
        total_lead: 0,
      };

      this.statuses.forEach((s) => {
        totalRow[s.name] = 0;
      });

      this.reportData.forEach((row) => {
        this.statuses.forEach((s) => {
          totalRow[s.name] += row[s.name] || 0;
        });
        totalRow.total_lead += row.total_lead || 0;
      });

      return totalRow;
    },
  },
  mounted() {
    this.fetchCampaignStatusReport();
  },
  watch: {
    rangeDates: {
      handler() {
        if (
          this.rangeDates.length === 2 &&
          this.rangeDates[0] &&
          this.rangeDates[1]
        ) {
          this.fetchCampaignStatusReport();
        }
      },
      deep: true,
    },
  },
  methods: {
    async fetchCampaignStatusReport() {
      this.loading = true;

      const [start_date, end_date] = this.rangeDates;

      try {
        const { data } = await AxiosInstance.get("reports/campaign-status", {
          params: {
            start_date,
            end_date,
          },
        });

        this.reportData = data;
      } catch (error) {
        this.$toast.error(
          "Rapor verisi alınamadı:",
          error?.response?.data || error
        );
        this.reportData = [];
      } finally {
        this.loading = false;
      }
    },
    getLeadStatusTranslate(status) {
      const translate = this.statuses.find((s) => s.name === status);
      switch (translate.name) {
        case "Teklif Taslağı Oluşturuldu":
          return "T.T.O.";
        case "Kullanıcı Kaydı Tamamlandı":
          return "K.K.T.";
        case "E-Posta Doğrulanması Bekleniyor":
          return "E.P.D.B.";
        default:
          return translate.name;
      }
    },
  },
};
</script>

<style scoped></style>
